/**
 * @Description
 */

import { FC } from 'react';
import styles from './index.module.less';
import cs from 'classnames';
import { isNotEmpty } from '@lhb/func';

const Scores: FC<any> = ({
  totalScore,
  scores,
}) => {
  // 在这里编写组件的逻辑和渲染
  return (
    <div className={styles.allScoreCon}>
      {
        isNotEmpty(totalScore) ? <div className={styles.totalScore}>
          <div className={cs(styles.score, 'fs-32 c-006')}>{isNotEmpty(totalScore) ? totalScore : '-'}</div>
          <div className={cs(styles.title, 'fs-12 c-006')}>综合评分</div>
        </div> : <></>
      }
      <div className={styles.otherScoreCon}>
        {scores.length ? scores.map((item: any, idx: number) => (
          <div key={idx} className={styles.scoreCard}>
            <span className={cs(styles.scoreVal, 'fs-14 c-222 font-weight-500')}>
              {item?.score}
            </span>
            <span className='fs-12 c-999 mt-2'>
              {item?.name}
            </span>
          </div>
        )) : <></>}
      </div>
    </div>
  );
};

export default Scores;
